// @greenlight-spec: 28-it-dashboard-ui.md
// @greenlight-spec: 26-versioning-update-strategy.md
import * as React from 'react';

import { UpdaterRunsList as SharedUpdaterRunsList } from '@/components/health/UpdaterRunsList';

import { internalHealthRunSource } from './internalHealthRunSource';

export function UpdaterRunsList(): React.JSX.Element {
  return <SharedUpdaterRunsList source={internalHealthRunSource} />;
}
